export default __webpack_public_path__ + "static/endless-waves-4eec4bdc74296035d679cf3f665ae3b1.gif";